<!-- SessionExpiryAlert.vue -->
<template>
  <teleport to="body">
    <!-- show only once countdown actually started -->
    <div v-if="visible">
      <!-- backdrop (does NOT close on click) -->
      <div class="alert-backdrop" />

      <!-- centered dialog -->
      <div
        class="alert-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="session-expiry-title"
        aria-live="assertive"
        tabindex="0"
        ref="dialog"
      >
        <button
          class="alert-close modal-icon-dismiss-action"
          @click="close"
          aria-label="Close session expiry warning"
        >
          ✕
        </button>

        <h2 id="session-expiry-title" class="alert-title">
          Session expiring soon
        </h2>
        <p class="alert-text">
          Your session will end in
          <strong class="alert-count">{{ mmss }}</strong>
        </p>
        <p class="alert-sub">
          Save your work now and restart your session. Closing this warning will
          not stop the logout.
        </p>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { SET_EXPIRY_WARNING } from "../../store/storeconstants";
export default {
  computed: {
    ...mapState("auth", {
      show: (s) => s.showExpiryWarning, // flipped to true at kickoff
      seconds: (s) => s.countdownSeconds, // ticks every second
    }),
    // visible only if the countdown actually started
    visible() {
      return this.show && this.seconds > 0;
    },
    mmss() {
      const s = Math.max(this.seconds, 0);
      const m = Math.floor(s / 60);
      const r = s % 60;
      return `${m}:${r.toString().padStart(2, "0")}`;
    },
  },
  methods: {
    // value can be the imported constant (the real type string)
    ...mapMutations("auth", { setWarningVisible: SET_EXPIRY_WARNING }),
    close() {
      this.setWarningVisible(false);
    },
  },
  mounted() {
    // focus the dialog for a11y, but only when visible
    this.$nextTick(() => this.$refs.dialog && this.$refs.dialog.focus());
  },
};
</script>

<style scoped>
/* darkened backdrop */
.alert-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9998;
}

/* centered modal */
.alert-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* center horizontally & vertically */
  width: min(520px, 92vw);
  padding: 20px 24px 18px;
  border-radius: 12px;

  /* red theme */
  background: #fee2e2;
  border: 1px solid #fca5a5;
  color: #7f1d1d;

  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  z-index: 9999;
}

/* header + text */
.alert-title {
  margin: 0 0 8px;
  font-weight: 700;
  font-size: 1.125rem;
}
.alert-text {
  margin: 0 0 6px;
  font-size: 0.975rem;
}
.alert-sub {
  margin: 0;
  font-size: 0.85rem;
  opacity: 0.85;
}

/* emphasis */
.alert-count {
  font-weight: 800;
}

/* close button (only this closes the warning) */
.alert-close {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #ef4444;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}
.alert-close:hover {
  filter: brightness(0.92);
}
</style>
